import { DocumentId } from "@bitory-gmbh/bsm";
import { RFC3339timestamp } from "@bitory-gmbh/nidavellir";
import { Address } from "../../addresses/types/address";
import { Representative } from "../../representatives/types/representative";

export type ConfirmationBase = {
  date: RFC3339timestamp;
  offerId?: DocumentId;
  offerDate?: RFC3339timestamp;
  offerReference: string;
  orderId?: DocumentId;
  orderDate?: RFC3339timestamp;
  orderReference: string;
  postalAddress: Address;
  representative: Representative;
};

export type ConfirmationBasePatchRequest = {
  date?: RFC3339timestamp;
  offerId?: DocumentId | null;
  offerDate?: RFC3339timestamp | null;
  offerReference?: string;
  orderId?: DocumentId | null;
  orderDate?: RFC3339timestamp | null;
  orderReference?: string;
  postalAddress?: Address | null;
  representative?: Representative | null;
};

/**
 * patchConfirmationBase helps to patc
 */
export function patchConfirmationBase<C extends ConfirmationBase>(
  c: C,
  patch: ConfirmationBasePatchRequest,
): C {
  return {
    ...c,
    ...patch,
  };
}
